import React, { useEffect, useState, useRef } from 'react';
import SidePanelItem from '../../../common/SidePanel/SidePanelItem';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { ref, child, get, set, push, update, remove, onValue, onChildAdded, onChildChanged } from "firebase/database";
import { db, dbQueues } from '../../../../FirebaseConfig';
import ModalConfirm from '../../../common/ModalConfirm/ModalConfirm'

export default ({ queueId, queueStatus }) => {
  const [paused, setPaused] = useState(queueStatus === 'Paused')

  const pauseRef = useRef();

  useEffect(()=>{
    setPaused(queueStatus === 'Paused')
  })

  const activeDescription = 'Temporarily stop joining';
  const pausedDescription = 'Start allowing to join';

  const handleToggleStatus =  () => {
    setPaused(!paused)



    // // Trigger queue status
    const queueRef = ref(db, `queues/${queueId}`);
    const status = paused===true?'Active':'Paused';
    update(queueRef, { status })
      .catch(err => {
        console.error("\tError with ", err.message)
      })

  };

  const openModal = () => {
    if (pauseRef.current) {
      pauseRef.current.openModal({
        id: queueId,
        text: 'Are you sure you want to pause the queue? ',
      });
    } else {
      console.error('pauseRef.current is null');
    }
  };

  return (
    <>
      <ModalConfirm 
        ref={pauseRef}
        onConfirm={handleToggleStatus}
        title="Pause Queue">
      </ModalConfirm>
      <SidePanelItem
        Icon={paused ? PlayArrowIcon : PauseIcon}
        title={paused ? 'Resume Queue' : 'Pause Queue'}
        description={paused ? pausedDescription : activeDescription}
        onClick={paused? handleToggleStatus: openModal}
        style={paused ? 'side-panel-item-selected' : 'side-panel-item'}
      />
    </>

  );
};
